export const loading = (state) => state.loading;
export const auctionIndicators = (state) => state.auctionIndicators;
export const batchIndicators = (state) => state.batchIndicators;
export const receiptIndicators = (state) => state.receiptIndicators;
